import Layout from "../../hocs/Layout";
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { get_partner_by_id, get_partner_by_vat } from "../../services/partner";
import { get_datos_oferta_erp, set_oferta_erp } from "../../services/ofertas";
import {
  get_pagador_by_id,

  register_pagador,
  register_partner_bank,
} from "../../services/pagador";
import { setLoader, removeLoader } from "../../redux/actions/loader";
import {
  get_paises,
  get_provincias,
  get_municipios,
  get_poblaciones,
  get_tipovia,
} from "../../redux/actions/auxiliares";
import { getBanks } from "../../services/auxiliares";
import { Button, Col, Form, Row, Card, Container } from "react-bootstrap";
import { TextInput, SelectInput } from "../../components/inputs/Inputs";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";

import { pagadorSchema } from "../../utils/validationSchemas";
import { AddressFields } from "../../components/inputs/AddressFields";
import { useAddressFields } from "../../components/hooks/useAddressFields";
import OfferWizardWrapper from "../../components/ofertas/OfferWizardWrapper";
import { useOfferWizard } from "../../components/ofertas/OfferWizardContext";

const normalizeTipoPersona = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";
  if (raw === "fisica" || raw === "física") return "fisica";
  if (raw === "juridica" || raw === "jurídica") return "juridica";
  return raw;
};

const normalizeSubTypeOffer = (value) =>
  String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

const extractSubtypeText = (value) => {
  if (Array.isArray(value)) {
    if (value.length > 1) return String(value[1] || value[0] || "");
    return String(value[0] || "");
  }
  if (value && typeof value === "object") {
    return String(value.name || value.display_name || value.label || value.value || value.id || "");
  }
  return String(value || "");
};

const isCambioTitularSubtype = (value) => {
  const normalized = normalizeSubTypeOffer(value);
  return (
    normalized.startsWith("cambio_titular")
    || normalized.startsWith("cambio_de_titular")
    || (normalized.startsWith("cambio") && normalized.includes("titular"))
  );
};

const OfertaPagadorForm = ({
  setLoader,
  removeLoader,
  paises,
  provincias,
  municipios,
  poblaciones,
  tipovia,
  get_paises,
  get_provincias,
  get_municipios,
  get_poblaciones,
  get_tipovia,
}) => {
  const params = useParams();
  const sector_type = params.sector_type;
  const { setActionHandler, setIsSubmitting } = useOfferWizard();

  useEffect(() => {
    const get_datos_iniciales = async () => {
      if (!params.oferta_id || params.oferta_id === "null" || params.oferta_id === 'undefined') {
        removeLoader();
        return;
      }
      setLoader("Cargando datos iniciales");
      await get_paises();
      await get_tipovia();
      removeLoader();
      setOfertaErp(await get_datos_oferta_erp(params.oferta_id));
    };

    get_datos_iniciales();
  }, [params.oferta_id, get_paises, get_tipovia, setLoader, removeLoader]);


  const [oferta_erp, setOfertaErp] = useState(null);
  const [pagador, setPagador] = useState(null);
  const [partner, setPartner] = useState(null);
  const [partnerLoaded, setPartnerLoaded] = useState(false); // ✅ Flag to prevent duplicate loading
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [clientAddress, setClientAddress] = useState(null);
  const [addressPrefillLabels, setAddressPrefillLabels] = useState({});
  const manualSearchRef = useRef(false);
  const isCambioTitular = isCambioTitularSubtype(oferta_erp?.sub_type_offer);
  const renewalSubtype = normalizeSubTypeOffer(extractSubtypeText(oferta_erp?.sub_type_offer));
  const renewalType = normalizeSubTypeOffer(
    oferta_erp?.type || oferta_erp?.type_offer || oferta_erp?.tipo_oferta
  );
  const isRenewalReadOnly =
    renewalSubtype.startsWith("renovacion")
    || renewalSubtype.includes("renovacion")
    || renewalType.startsWith("renovacion");

  const extractMany2OneId = useCallback((value) => {
    if (Array.isArray(value) && value.length > 0 && Number(value[0])) {
      return Number(value[0]);
    }
    if (value && typeof value === "object" && value.id !== undefined && Number(value.id)) {
      return Number(value.id);
    }
    if (typeof value === "number" && Number.isFinite(value)) {
      return value;
    }
    if (typeof value === "string" && value.trim() !== "" && Number(value)) {
      return Number(value);
    }
    return null;
  }, []);

  const defaultValues = useMemo(() => ({
    bank: "",
    iban: "",
    cliente_tipo_persona: "",
    cliente_nombre: "",
    cliente_apellidos: "",
    cliente_vat: "",
    cliente_telefono_1: "",
    cliente_telefono_2: "",
    cliente_email_1: "",
    cliente_pais: "",
    cliente_aclarador: "",
    partnerSepa: true,
    differentAddress: false,
    cliente_nv: "",
    cliente_pt: "",
    cliente_pu: "",
    cliente_es: "",
    cliente_pnp: "",
    cliente_dp: "",
    cliente_id_pais: "",
    cliente_id_provincia: "",
    cliente_id_municipi: "",
    cliente_id_poblacio: "",
    cliente_tv: "",
    state: "iban",
    secuence: 0,
  }), []);

  const {
    handleSubmit,
    control,
    watch,
    getValues,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    resolver: yupResolver(pagadorSchema),
  });

  const partnerSepa = watch("partnerSepa");
  const idPais = watch("cliente_id_pais");
  const idProv = watch("cliente_id_provincia");

  const fetchBank = useCallback(async (iban) => {
    if (iban.length === 24) {
      try {
        const banco = await getBanks(iban);
        if (banco && banco[0]) {
          setValue("bank", { name: banco[0].name, id: banco[0].id });
        }
      } catch (error) {
        console.error("Error fetching bank:", error);
        // Mantener el valor actual si hay error
      }
    }
  }, [setValue]);

  // ✅ Load partner data only once when oferta_erp is available

  // Sync submitting state
  useEffect(() => {
    setIsSubmitting(isSubmitting);
  }, [isSubmitting, setIsSubmitting]);

  useEffect(() => {
    if (oferta_erp && !partnerLoaded) {
      const loadPartnerData = async () => {
        const partnerId =
          extractMany2OneId(oferta_erp.partner_id) ||
          extractMany2OneId(oferta_erp.titular);

        if (!partnerId) {
          return;
        }

        const partnerData = await get_partner_by_id(partnerId);
        if (!partnerData) {
          return;
        }

        setPartner(partnerData);
        setPartnerLoaded(true); // ✅ Mark as loaded

        if (oferta_erp.num_cta) {
          const iban = oferta_erp.num_cta[1].replaceAll(" ", "");
          setValue("iban", iban);
          await fetchBank(iban);
        }
      };

      loadPartnerData();
    }
  }, [oferta_erp, partnerLoaded, setValue, fetchBank, extractMany2OneId, isCambioTitular]);

  const {
    loadingProv,
    loadingMuni,
    loadingPob,
    error: loadError,
    fetchProvincias,
    fetchMunicipios,
    fetchPoblaciones
  } = useAddressFields({
    get_provincias,
    get_municipios,
    get_poblaciones,
    partnerLoading
  });

  const setFields = useCallback((data) => {
    const partnerSepa = getValues().partnerSepa;
    const currentIban = getValues().iban;
    const differentAddress = getValues().differentAddress;

    // Helper to safely get ID from array or value
    const getId = (val) => {
      if (Array.isArray(val) && val.length > 0) return val[0];
      if (val && typeof val === "object" && val.id !== undefined) return val.id;
      return val;
    };

    const getLabel = (val) => {
      if (Array.isArray(val) && val.length > 1) return val[1] || "";
      if (val && typeof val === "object") {
        return val.name || val.display_name || val.label || "";
      }
      return "";
    };

    const countryId = getId(data.country_id ?? data.country) || 67;
    const prefillLabels = {
      provincia: getLabel(data.state_id),
      municipio: getLabel(data.id_municipi),
      poblacion: getLabel(data.id_poblacio),
    };

    setAddressPrefillLabels(prefillLabels);

    reset({
      iban: currentIban,
      partnerSepa: partnerSepa,
      differentAddress: differentAddress,
      cliente_tipo_persona: normalizeTipoPersona(data.cifnif === "NI" ? "fisica" : "juridica"),
      cliente_nombre: data.first_name || "",
      cliente_apellidos: data.last_name || "",
      cliente_vat: data.vat || "",
      cliente_telefono_1: data.phone || "",
      cliente_telefono_2: data.mobile || "",
      cliente_email_1: data.email || "",
      cliente_pais: countryId,
      cliente_aclarador: data.aclarador || "",
      cliente_nv: data.nv || "",
      cliente_pt: data.pt || "",
      cliente_pu: data.pu || "",
      cliente_es: data.es || "",
      cliente_pnp: data.pnp || "",
      cliente_dp: data.zip || "",
      cliente_id_pais: countryId,
      cliente_id_provincia: getId(data.state_id) || "",
      cliente_id_municipi: getId(data.id_municipi) || "",
      cliente_id_poblacio: getId(data.id_poblacio) || "",
      cliente_tv: getId(data.tv) || "",
    });

    const setLocation = async () => {
      setLoader("Cargando cliente");
      const cId = getId(data.country_id ?? data.country);
      const sId = getId(data.state_id);
      const mId = getId(data.id_municipi);

      if (cId) await get_provincias(cId);
      if (sId) await get_municipios(sId);
      if (mId) await get_poblaciones(mId);

      // Save client address for restoration
      const address = {
        cliente_nv: data.nv || "",
        cliente_pt: data.pt || "",
        cliente_pu: data.pu || "",
        cliente_es: data.es || "",
        cliente_pnp: data.pnp || "",
        cliente_dp: data.zip || "",
        cliente_id_pais: countryId,
        cliente_id_provincia: getId(data.state_id) || "",
        cliente_id_municipi: getId(data.id_municipi) || "",
        cliente_id_poblacio: getId(data.id_poblacio) || "",
        cliente_tv: getId(data.tv) || "",
        cliente_aclarador: data.aclarador || "",
        prefillLabels,
      };
      setClientAddress(address);

      setPartnerLoading(false);
      removeLoader();
    };
    setLocation();
  }, [getValues, reset, setLoader, get_provincias, get_municipios, get_poblaciones, removeLoader]);

  const handleChangeSepa = useCallback((value) => {
    const currentIban = getValues("iban");
    const currentBank = getValues("bank");

    setValue("partnerSepa", value);

    if (!value) {
      reset({
        ...defaultValues,
        partnerSepa: value,
        iban: currentIban,
        bank: currentBank,
      });
    } else {
      setFields(partner);
      // Preservar IBAN y banco
      setValue("iban", currentIban);
      if (currentBank) {
        setValue("bank", currentBank);
      }
    }
  }, [getValues, setValue, reset, defaultValues, setFields, partner]);

  useEffect(() => {
    if (partner && !pagador) {
      setPartnerLoading(true);

      const ownerId =
        extractMany2OneId(oferta_erp?.partner_id) ||
        extractMany2OneId(oferta_erp?.titular);
      const payerId = extractMany2OneId(oferta_erp?.pagador_autorizacion_sepa);

      if (
        // Si no hay pagador registrado (1er ingreso) o si el pagador es el mismo que el titular
        !payerId || (ownerId && ownerId === payerId)
      ) {
        setValue("partnerSepa", true);
        setFields(partner);
      } else {
        setValue("partnerSepa", false);
        handleChangeSepa(false);
        const getPagador = async () => {
          const pagadorLoaded = await get_pagador_by_id(payerId);
          if (pagadorLoaded) {
            setPagador(pagadorLoaded);
          } else {
            // Fallback seguro: si no encontramos pagador, mantenemos datos del titular
            setValue("partnerSepa", true);
            setFields(partner);
          }
        };
        getPagador();
      }
    }
  }, [partner, pagador, oferta_erp, setFields, handleChangeSepa, extractMany2OneId, setValue, isCambioTitular]);

  useEffect(() => {
    if (pagador && partnerLoading) {
      setFields(pagador);
    }
  }, [pagador, partnerLoading, setFields]);

  useEffect(() => {
    if (partner && partnerSepa) {
      // Sync all personal info from partner
      setValue("cliente_nombre", partner.first_name || "");
      const finalApellidos = partner.last_name || partner.name || "";
      setValue("cliente_apellidos", finalApellidos);
      setValue("cliente_vat", partner.vat || "");
      setValue("cliente_telefono_1", partner.phone || "");
      setValue("cliente_telefono_2", partner.mobile || "");
      setValue("cliente_email_1", partner.email || "");
      setValue("cliente_tipo_persona", normalizeTipoPersona(partner.cifnif === "NI" ? "fisica" : "juridica"));

      const countryRaw = partner.country_id ?? partner.country;
      const countryId = Array.isArray(countryRaw)
        ? countryRaw[0]
        : (countryRaw && typeof countryRaw === "object" && countryRaw.id !== undefined)
          ? countryRaw.id
          : (countryRaw || 67);
      setValue("cliente_pais", countryId);
    }
  }, [partnerSepa, partner, setValue]);

  const changeIban = (event) => {
    // Evita que se agreguen espacios al IBAN
    if (!event.key.trim()) {
      event.preventDefault();
    }
  };

  // Removed fetchBank as it was defined as useCallback above


  const handleSearchPagador = async () => {
    manualSearchRef.current = true;
    const vat = getValues("cliente_vat");
    if (!vat) return;

    const partnerFound = await get_partner_by_vat(vat);
    if (partnerFound) {
      setPartnerLoading(true);
      setFields(partnerFound);
      // Note: IBAN is not automatically set here unless it's in the partnerFound object and we map it.
      // The requirement says "The IBAN will be deleted by hand" or "Preload IBAN... if exists".
      // If get_partner_by_vat returns detailed info including IBAN, we could set it.
      // For now, we focus on address fields as per `setFields`.
    }
    manualSearchRef.current = false;
  };

  const handleDifferentAddress = async (isChecked) => {
    setValue("differentAddress", isChecked);
    if (isChecked) {
      // Clear address fields for manual entry
      setValue("cliente_nv", "");
      setValue("cliente_pt", "");
      setValue("cliente_pu", "");
      setValue("cliente_es", "");
      setValue("cliente_pnp", "");
      setValue("cliente_dp", "");
      setValue("cliente_id_municipi", "");
      setValue("cliente_id_poblacio", "");
      setValue("cliente_tv", "");
      setValue("cliente_id_pais", 67); // Default to Spain for manual entry
      setValue("cliente_id_provincia", "");
      setValue("cliente_aclarador", "");
    } else if (clientAddress) {
      // Restore client address
      setAddressPrefillLabels(clientAddress.prefillLabels || {});
      setValue("cliente_nv", clientAddress.cliente_nv || "");
      setValue("cliente_pt", clientAddress.cliente_pt || "");
      setValue("cliente_pu", clientAddress.cliente_pu || "");
      setValue("cliente_es", clientAddress.cliente_es || "");
      setValue("cliente_pnp", clientAddress.cliente_pnp || "");
      setValue("cliente_dp", clientAddress.cliente_dp || "");
      setValue("cliente_tv", clientAddress.cliente_tv || "");
      setValue("cliente_aclarador", clientAddress.cliente_aclarador || "");
      setValue("cliente_id_pais", clientAddress.cliente_id_pais || 67);

      setLoader("Recuperando dirección del cliente...");
      try {
        if (clientAddress.cliente_id_pais) {
          await fetchProvincias(clientAddress.cliente_id_pais);
        }
        if (clientAddress.cliente_id_provincia) {
          setValue("cliente_id_provincia", clientAddress.cliente_id_provincia);
          await fetchMunicipios(clientAddress.cliente_id_provincia);
        }
        if (clientAddress.cliente_id_municipi) {
          setValue("cliente_id_municipi", clientAddress.cliente_id_municipi);
          await fetchPoblaciones(clientAddress.cliente_id_municipi);
        }
        if (clientAddress.cliente_id_poblacio) {
          setValue("cliente_id_poblacio", clientAddress.cliente_id_poblacio, { shouldValidate: true });
        }
      } catch (e) {
        console.error("Error restoring address cascade", e);
      } finally {
        removeLoader();
      }
    }
  };




  const onSubmit = useCallback(async () => {
    if (isRenewalReadOnly) {
      return;
    }

    const data = getValues();
    let pagadorId = partner.id;
    const isSameAddressAsClient = !data.differentAddress;
    let datos_bank = {
      city: data.cliente_id_municipi,
      zip: data.cliente_dp,
      sequence: 0,
      country_id: data.cliente_id_pais,
      state: "iban",
      street: data.cliente_nv,
      state_id: data.cliente_id_provincia,
      partner_id: partner.id, //es el dueño del contrato
      bank: data.bank.id,
      iban: data.iban,
      acc_country_id: data.cliente_id_pais,
      owner_address_id: isSameAddressAsClient ? partner.address[0] : null,
      owner_id: partner.id, //Owner es el dueño de la cuenta bancaria
      owner_name: partner.name,
    };
    if (!partnerSepa) {
      const datos = {
        cliente_tipo_persona: data.cliente_tipo_persona,
        cliente_nombre: data.cliente_nombre,
        cliente_apellidos: data.cliente_apellidos,
        cliente_vat: data.cliente_vat,
        cliente_telefono_1: data.cliente_telefono_1,
        cliente_telefono_2: data.cliente_telefono_2,
        cliente_email_1: data.cliente_email_1,
        country_id: data.cliente_id_pais,
        cliente_id_provincia: data.cliente_id_provincia,
        cliente_id_municipi: data.cliente_id_municipi,
        cliente_id_poblacio: data.cliente_id_poblacio,
        cliente_aclarador: data.cliente_aclarador,
        cliente_tv: data.cliente_tv,
        cliente_nv: data.cliente_nv,
        cliente_pt: data.cliente_pt,
        cliente_pu: data.cliente_pu,
        cliente_es: data.cliente_es,
        cliente_pnp: data.cliente_pnp,
        cliente_dp: data.cliente_dp,
        cliente_cpo: null,
        cliente_cpa: null,
      };
      const pagadorRes = await register_pagador(datos);
      pagadorId = pagadorRes.id;
      datos_bank.owner_id = pagadorRes.id;
      datos_bank.owner_address_id = isSameAddressAsClient
        ? partner.address[0]
        : pagadorRes.address?.[0] || partner.address[0];
      datos_bank.owner_name = pagadorRes.name;
    }
    const partnerBank = await register_partner_bank(
      params.oferta_id,
      datos_bank
    );
    const datos_oferta = {
      pagador_autorizacion_sepa: pagadorId,
      entidad_bancaria: data.bank.name,
      direccion_clte_sepa: isSameAddressAsClient
        ? partner.address[0]
        : (datos_bank.owner_address_id || partner.address[0]),
      num_cta: partnerBank.id,
    };
    await set_oferta_erp(
      params.oferta_id,
      datos_oferta,
      sector_type,
      oferta_erp?.sub_type_offer,
      data.cliente_vat
    );
  }, [getValues, isRenewalReadOnly, partner, partnerSepa, params.oferta_id, sector_type, oferta_erp]);

  // Register wizard actions
  useEffect(() => {
    setActionHandler({
      onNext: () => handleSubmit(onSubmit)(),
      onSave: () => handleSubmit(onSubmit)()
    });
  }, [setActionHandler, handleSubmit, onSubmit]);

  // Removed handleChangeSepa as it was defined as useCallback above
  const idMuni = watch("cliente_id_municipi");
  const tipoPersona = normalizeTipoPersona(watch("cliente_tipo_persona"));
  const disableSearchPartner = watch("cliente_vat");
  const selectedCountryId = Number(watch("cliente_pais") || 67);
  const selectedCountryName =
    paises?.find((pais) => Number(pais.id) === selectedCountryId)?.name ||
    (selectedCountryId === 67 ? "España" : `País ${selectedCountryId}`);
  const tipoPersonaLabel =
    tipoPersona === "fisica"
      ? "Física"
      : tipoPersona === "juridica"
        ? "Jurídica"
        : (watch("cliente_tipo_persona") || "");

  return (

    <div className="py-4">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} md={12}>
            <Card className="detail-card border-0 shadow-lg rounded-4 overflow-hidden">
              <Card.Header className="bg-white border-bottom-0 pt-4 pb-0 text-center">
                <h2 className="text-primary fw-bold mb-0">Datos del Pagador</h2>
              </Card.Header>
              <Card.Body className="p-4 p-md-5">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  {isRenewalReadOnly && (
                    <div className="alert alert-secondary mb-4 shadow-sm border-0">
                      Esta pantalla es solo lectura en renovacion.
                    </div>
                  )}
                  <div style={isRenewalReadOnly ? { pointerEvents: "none" } : undefined}>
                    <fieldset disabled={isRenewalReadOnly}>


                      {/* Section: Same as Client Toggle */}
                      <div className="bg-light p-4 rounded-4 border border-light mb-4 text-center">
                        <Form.Check
                          type="switch"
                          id="partnerSepa"
                          label={
                            <span className="fw-bold text-primary h5 mb-0">
                              El pagador es el mismo que el titular del contrato
                            </span>
                          }
                          checked={partnerSepa}
                          onChange={(e) => handleChangeSepa(e.target.checked)}
                          className="d-inline-block custom-switch"
                        />
                        <p className="text-muted small mt-2 mb-0">
                          Si se activa, se usarán automáticamente los datos de contacto y facturación del cliente.
                        </p>
                      </div>

                      {/* Section: Bank Details */}
                      <div className="bg-light p-4 rounded-4 border border-light mb-4">
                        <h5 className="fw-bold text-secondary mb-3">Datos Bancarios</h5>
                        <Row className="g-3">
                          <Col lg={6} md={12}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">IBAN</label>
                            <Controller
                              name="iban"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  onKeyDown={(e) => changeIban(e)}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    fetchBank(e.target.value);
                                  }}
                                  error={error?.message}
                                  hint="No ingresar espacios"
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                          <Col lg={6} md={12}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Entidad Bancaria</label>
                            <Controller
                              name="bank.name"
                              control={control}
                              render={({ field }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  readOnly
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </div>

                      {/* Section: Document & Search */}
                      <div className="bg-light p-4 rounded-4 border border-light mb-4">
                        <Row className="g-3 align-items-end">
                          <Col lg={4} md={6}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Nacionalidad Documento</label>
                            {partnerSepa ? (
                              <Form.Control
                                value={selectedCountryName}
                                readOnly
                                className="bg-white shadow-sm"
                              />
                            ) : (
                              <Controller
                                name="cliente_pais"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                  <SelectInput
                                    {...field}
                                    noFloating={true}
                                    error={error?.message}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setValue("cliente_pais", e.target.value);
                                    }}
                                    className="bg-white shadow-sm"
                                  >
                                    <option value="" disabled>Seleccione nacionalidad</option>
                                    {paises?.map((pais) => (
                                      <option key={pais.id} value={pais.id}>
                                        {pais.name}
                                      </option>
                                    ))}
                                    {field.value && (!paises || !paises.find(p => p.id === Number(field.value))) && (
                                      <option value={field.value} disabled>
                                        {Number(field.value) === 67 ? "España" : `País ${field.value}`}
                                      </option>
                                    )}
                                  </SelectInput>
                                )}
                              />
                            )}
                          </Col>
                          <Col lg={4} md={6}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Nº Documento</label>
                            <Controller
                              name="cliente_vat"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={partnerSepa}
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                          {!partnerSepa && (
                            <Col lg={4} md={12}>
                              <Button
                                variant="primary"
                                onClick={handleSearchPagador}
                                className="rounded-pill w-100 fw-bold shadow-sm py-2"
                                disabled={!disableSearchPartner}
                              >
                                Buscar Pagador
                              </Button>
                            </Col>
                          )}
                        </Row>
                      </div>

                      {/* Section: Personal Info */}
                      <div className="bg-light p-4 rounded-4 border border-light mb-4">
                        <h5 className="fw-bold text-secondary mb-3">Datos Personales</h5>
                        <Row className="g-3">
                          <Col lg={4} md={6}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Tipo de Persona</label>
                            {partnerSepa ? (
                              <Form.Control
                                value={tipoPersonaLabel}
                                readOnly
                                className="bg-white shadow-sm"
                              />
                            ) : (
                              <Controller
                                name="cliente_tipo_persona"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                  <SelectInput
                                    {...field}
                                    value={normalizeTipoPersona(field.value)}
                                    noFloating={true}
                                    error={error?.message}
                                    className="bg-white shadow-sm"
                                  >
                                    <option value="" disabled>Seleccione tipo</option>
                                    <option value="fisica">Física</option>
                                    <option value="juridica">Jurídica</option>
                                    {field.value && !["fisica", "juridica"].includes(normalizeTipoPersona(field.value)) && (
                                      <option value={field.value}>{field.value}</option>
                                    )}
                                  </SelectInput>
                                )}
                              />
                            )}
                          </Col>
                          {tipoPersona === "fisica" && (
                            <Col lg={4} md={6}>
                              <label className="text-muted small fw-bold text-uppercase mb-2">Nombre</label>
                              <Controller
                                name="cliente_nombre"
                                control={control}
                                render={({ field, fieldState: { error } }) => (
                                  <TextInput
                                    {...field}
                                    noFloating={true}
                                    error={error?.message}
                                    readOnly={partnerSepa}
                                    className="bg-white shadow-sm"
                                  />
                                )}
                              />
                            </Col>
                          )}
                          <Col lg={tipoPersona === "fisica" ? 4 : 8} md={6}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">
                              {tipoPersona !== "fisica" ? "Nombre de la Empresa / Razón Social" : "Apellidos"}
                            </label>
                            <Controller
                              name="cliente_apellidos"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={partnerSepa}
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </div>

                      {/* Section: Address Source */}
                      <div className="bg-light p-4 rounded-4 border border-light mb-4">
                        <Row className="g-3">
                          <Col md={12}>
                            {!watch("differentAddress") && clientAddress && (
                              <div className="alert alert-info mb-3 py-2 px-3 d-flex align-items-center">
                                <i className="bi bi-check-circle-fill me-2"></i>
                                <span className="mb-0 small">
                                  <strong>Usando dirección del cliente</strong> - Los datos se han precargado automáticamente
                                </span>
                              </div>
                            )}
                            <Form.Check
                              type="checkbox"
                              id="differentAddress"
                              label={
                                <span className="fw-bold text-secondary">
                                  Crear una dirección nueva para el pagador (distinta a la del cliente)
                                </span>
                              }
                              checked={watch("differentAddress") || false}
                              onChange={(e) => handleDifferentAddress(e.target.checked)}
                              className="mb-0 custom-checkbox"
                            />
                            {watch("differentAddress") && (
                              <small className="text-muted d-block mt-2">
                                Ingrese la nueva dirección del pagador a continuación.
                              </small>
                            )}
                          </Col>
                        </Row>
                      </div>

                      {/* Section: Contact + Address */}
                      <div className="bg-light p-4 rounded-4 border border-light mb-4">
                        <h5 className="fw-bold text-secondary mb-3">Contacto y Dirección</h5>
                        <Row className="g-3">
                          <Col lg={4} md={6}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Email</label>
                            <Controller
                              name="cliente_email_1"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={partnerSepa && !watch("differentAddress")}
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                          <Col lg={4} md={6}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Teléfono Fijo</label>
                            <Controller
                              name="cliente_telefono_1"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={partnerSepa && !watch("differentAddress")}
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                          <Col lg={4} md={6}>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Teléfono Móvil</label>
                            <Controller
                              name="cliente_telefono_2"
                              control={control}
                              render={({ field, fieldState: { error } }) => (
                                <TextInput
                                  {...field}
                                  noFloating={true}
                                  error={error?.message}
                                  readOnly={partnerSepa && !watch("differentAddress")}
                                  className="bg-white shadow-sm"
                                />
                              )}
                            />
                          </Col>
                        </Row>

                        <AddressFields
                          control={control}
                          errors={errors}
                          paises={paises}
                          provincias={provincias}
                          municipios={municipios}
                          poblaciones={poblaciones}
                          tipovia={tipovia}
                          loadingProv={loadingProv}
                          loadingMuni={loadingMuni}
                          loadingPob={loadingPob}
                          idPais={idPais}
                          idProv={idProv}
                          idMuni={idMuni}
                          onPaisChange={fetchProvincias}
                          onProvinciaChange={fetchMunicipios}
                          onMunicipioChange={fetchPoblaciones}
                          prefix="cliente_"
                          noFloating={true}
                          readOnly={!watch("differentAddress")}
                          loadError={loadError}
                          prefillLabels={addressPrefillLabels}
                        />
                      </div>

                    </fieldset>
                  </div>

                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const OfertaPagador = (props) => {
  const { sector_type, oferta_id } = useParams();
  return (
    <Layout
      offerContext={{ sector_type, oferta_id }}
    >
      <OfferWizardWrapper currentStep="pagador">
        <OfertaPagadorForm {...props} />
      </OfferWizardWrapper>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  paises: state.Auxiliares.paises,
  provincias: state.Auxiliares.provincias,
  municipios: state.Auxiliares.municipios,
  poblaciones: state.Auxiliares.poblaciones,
  tipovia: state.Auxiliares.tipovia,
});

export default connect(mapStateToProps, {
  get_paises,
  get_provincias,
  get_municipios,
  get_poblaciones,
  get_tipovia,
  setLoader,
  removeLoader,
})(OfertaPagador);
